function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Q5sward"
}, /*#__PURE__*/React.createElement("g", {
  id: "Q5s3"
}, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M442,26.4l-1.9-1.7c-1-0.9-2.6-0.8-3.4,0.2l-32.3,36.4c-0.2,0.3-0.2,0.6,0.1,0.9l4.6,4.1 c0.3,0.2,0.6,0.2,0.9-0.1l32.3-36.4C443.1,28.8,443,27.3,442,26.4z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 387.9,
  y: 63.7,
  transform: "matrix(0.7482 0.6635 -0.6635 0.7482 145.7195 -252.7675)",
  className: "st0",
  width: 36,
  height: 3.7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M316.2,168.6l-2.8-2.5c-1.5-1.3-1.6-3.7-0.3-5.2l84.4-94.4c1.3-1.5,3.7-1.6,5.2-0.3l2.8,2.5 c1.5,1.3,1.6,3.7,0.3,5.2l-84.4,94.4C320,169.9,317.7,170,316.2,168.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M318.4,154.3l1.8,1.7c0.3,0.3,0.3,0.8,0,1.2l-0.6,0.9c-0.3,0.4-0.3,0.9,0,1.2l2.7,2.5 c0.3,0.3,1.3,0,1.6-0.4l0.6-0.7c0.3-0.3,0.8-0.4,1.1-0.2l1.2,1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M397.7,81.8l-4.7-0.6c-0.8-0.1-1.3-0.6-1.5-1.4l-1.1-4.6c-0.2-0.7,0-1.5,0.5-2l7.6-8.5 c0.8-0.9,2.1-1.1,2.9-0.3l5.8,5.2c0.8,0.7,0.8,2.1,0,3l-7.6,8.5C399.2,81.6,398.5,81.9,397.7,81.8z"
})), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 396.5,
  y1: 84.6,
  x2: 383.6,
  y2: 82.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 394.3,
  y1: 87,
  x2: 381.5,
  y2: 84.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 392.2,
  y1: 89.4,
  x2: 379.3,
  y2: 87.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 390,
  y1: 91.9,
  x2: 377.1,
  y2: 89.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 387.9,
  y1: 94.3,
  x2: 375,
  y2: 92
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 385.7,
  y1: 96.7,
  x2: 372.8,
  y2: 94.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 389.9,
  y1: 83.7,
  x2: 388.4,
  y2: 77
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 385.9,
  y1: 88.2,
  x2: 385.3,
  y2: 85.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 388,
  y1: 85.8,
  x2: 387.5,
  y2: 83
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 383.7,
  y1: 90.6,
  x2: 383.1,
  y2: 87.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 381.6,
  y1: 93,
  x2: 381,
  y2: 90.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st0",
  x1: 379.4,
  y1: 95.4,
  x2: 378.8,
  y2: 92.6
}))), /*#__PURE__*/React.createElement("g", {
  id: "Q5s4"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M260,27.9l1.9-1.7c1-0.9,2.6-0.8,3.4,0.2l32.3,36.4c0.2,0.3,0.2,0.6-0.1,0.9l-4.6,4.1 c-0.3,0.2-0.6,0.2-0.9-0.1l-32.3-36.4C258.9,30.4,259,28.8,260,27.9z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 278.2,
  y: 65.3,
  transform: "matrix(-0.7482 0.6635 -0.6635 -0.7482 562.3724 -79.0977)",
  className: "st2",
  width: 36,
  height: 3.7
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st3",
  d: "M385.9,170.2l2.8-2.5c1.5-1.3,1.6-3.7,0.3-5.2l-84.4-94.4c-1.3-1.5-3.7-1.6-5.2-0.3l-2.8,2.5 c-1.5,1.3-1.6,3.7-0.3,5.2l84.4,94.4C382,171.4,384.4,171.6,385.9,170.2z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M383.7,155.8l-1.8,1.7c-0.3,0.3-0.3,0.8,0,1.2l0.6,0.9c0.3,0.4,0.3,0.9,0,1.2l-2.7,2.5 c-0.3,0.3-1.3,0-1.6-0.4l-0.6-0.7c-0.3-0.3-0.8-0.4-1.1-0.2l-1.2,1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M304.3,83.4l4.7-0.6c0.8-0.1,1.3-0.6,1.5-1.4l1.1-4.6c0.2-0.7,0-1.5-0.5-2l-7.6-8.5 c-0.8-0.9-2.1-1.1-2.9-0.3l-5.8,5.2c-0.8,0.7-0.8,2.1,0,3l7.6,8.5C302.9,83.2,303.6,83.5,304.3,83.4z"
})), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 305.6,
  y1: 86.2,
  x2: 318.5,
  y2: 84
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 307.7,
  y1: 88.6,
  x2: 320.6,
  y2: 86.4
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 309.9,
  y1: 91,
  x2: 322.8,
  y2: 88.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 312,
  y1: 93.4,
  x2: 324.9,
  y2: 91.2
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 314.2,
  y1: 95.8,
  x2: 327.1,
  y2: 93.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 316.3,
  y1: 98.2,
  x2: 329.2,
  y2: 96
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 312.2,
  y1: 85.3,
  x2: 313.6,
  y2: 78.6
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 316.2,
  y1: 89.7,
  x2: 316.8,
  y2: 86.9
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 314,
  y1: 87.3,
  x2: 314.6,
  y2: 84.5
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 318.3,
  y1: 92.1,
  x2: 318.9,
  y2: 89.3
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 320.5,
  y1: 94.6,
  x2: 321.1,
  y2: 91.8
}), /*#__PURE__*/React.createElement("line", {
  className: "st2",
  x1: 322.6,
  y1: 97,
  x2: 323.2,
  y2: 94.2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Q5s2"
}, /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M470.2,6.1L467,4.5l-53.9,110.4l9.3,4.6l50.9-104.2C475,11.8,473.6,7.7,470.2,6.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st4",
  d: "M413.1,114.9l51-104.4c2.3,3,2.9,7.2,1.1,10.9l-46.9,96.1L413.1,114.9z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 410.7,
  y: 117.1,
  transform: "matrix(0.8986 0.4387 -0.4387 0.8986 94.9736 -170.4168)",
  className: "st4",
  width: 11.1,
  height: 6.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st5",
  d: "M391.9,173.2l-2.3-1.1c-1.2-0.6-1.7-2.1-1.1-3.3l21.4-43.7c0.1-0.3,0.5-0.4,0.8-0.3l5.6,2.7 c0.3,0.1,0.4,0.5,0.3,0.8L395.1,172C394.5,173.2,393.1,173.7,391.9,173.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 396.3,
  y: 122.9,
  transform: "matrix(0.8986 0.4387 -0.4387 0.8986 96.7352 -169.1226)",
  className: "st5",
  width: 36,
  height: 3.7
})), /*#__PURE__*/React.createElement("g", {
  id: "Q5s1"
}, /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M171.8,89.6l1-3.4l117.3,36.5l-3.1,9.9L176.3,98.2C172.7,97,170.6,93.2,171.8,89.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st6",
  d: "M290.1,122.7l-111-34.5c0.6,3.8,3.3,7.1,7.2,8.3l102.1,31.8L290.1,122.7z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 286.3,
  y: 125.4,
  transform: "matrix(-0.2971 0.9549 -0.9549 -0.2971 501.4394 -111.7983)",
  className: "st6",
  width: 11.1,
  height: 6.5
}), /*#__PURE__*/React.createElement("path", {
  className: "st7",
  d: "M347.1,147.2l0.7-2.4c0.4-1.3-0.3-2.7-1.6-3.1l-46.5-14.5c-0.3-0.1-0.7,0.1-0.8,0.4l-1.8,5.9 c-0.1,0.3,0.1,0.7,0.4,0.8l46.5,14.5C345.3,149.2,346.7,148.4,347.1,147.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 278.4,
  y: 128.5,
  transform: "matrix(-0.2971 0.9549 -0.9549 -0.2971 508.9422 -113.9997)",
  className: "st7",
  width: 36,
  height: 3.7
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Q5man"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M318,150.1c0,0-1.4,9.5,6.8,13.2c13.8,6.3,14.9-2.7,14.9-2.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st8",
  d: "M382,150.3c0,0,2.2,9.2-6,13c-13.8,6.3-14.9-2.7-14.9-2.7"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M415,130l-19.2-10.1c-1.1-0.5-1.9-1.5-2.2-2.6l-10.4-30.6c-0.6-1.7-1.5-5-4.3-5.3c-0.6-6.6-1.1-12.6-1.6-17.2 c-2.1-21.9-4.2-46.5-27.2-46.5s-25.6,25.7-27.5,47.9c-0.4,4.3-0.8,9.8-1.3,15.9l0,0c-3.1,0-4.1,3.6-4.7,5.4l-17.7,52 c-0.6,1.8,0.1,3.8,1.6,4.5c1.5,0.7,3.1-0.1,3.7-1.9l15.7-42.7c-1.5,19.3-2.8,39-2.8,47.7c0,20.1,66,20.1,66,0 c0-9.6-1.2-28.5-2.7-46.8L389,125l23,11c2,1,4.3,0.5,5-1C418,133,417,131,415,130z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 324.7,
  y1: 192.2,
  x2: 328,
  y2: 164.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M330,198.3l-16.5-0.2c0,0,6.9-6.4,13-5.4S330,198.3,330,198.3z"
}), /*#__PURE__*/React.createElement("line", {
  className: "st10",
  x1: 376.1,
  y1: 192.2,
  x2: 372.9,
  y2: 164.6
}), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M370.8,198l16.5,0.5c0,0-6.7-6.7-12.9-6C368.3,193.3,370.8,198,370.8,198z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  className: "st12",
  cx: 343.8,
  cy: 53.8,
  r: 1.7
}), /*#__PURE__*/React.createElement("circle", {
  className: "st12",
  cx: 356.3,
  cy: 53.8,
  r: 1.7
})), /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M334.3,64.3c1.9,4.2,7.4-1.4,15.8-1.4H350c8.4,0,13.9,5.7,15.8,1.4"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
  points: "321.5,64.8 321,70.7 323.2,71.9 323.7,66.1  "
}), /*#__PURE__*/React.createElement("polygon", {
  points: "378.4,65.9 378.9,71.8 376.7,73 376.1,67.2  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st13",
  d: "M336.7,147.9l-1.1,8.4c-0.3,2.7,1.8,5.1,4.5,5.1h19c2.6,0,4.7-2.2,4.6-4.9l-0.6-8.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M292.8,27c0-7.3,25.5-18.9,57-18.9s57,11.6,57,18.9s-25.5,13.1-57,13.1S292.8,34.2,292.8,27z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M342.9,118.6c-21.4,0-24.1-6.2-24.1-6.2l-10.5,29.9c0,0,17.4,11.7,25.1,9.1 C340.6,148.9,342.9,118.6,342.9,118.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M310.2,138.7c5.2,2.9,16.9,8.5,21.9,6.9c5-1.6,7.6-16.6,8.8-25.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M356.7,118.6c21.4,0,24.1-6.2,24.1-6.2l10.5,29.9c0,0-17.4,11.7-25.1,9.1C359,148.9,356.7,118.6,356.7,118.6 z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M361.5,124.6c-6.4,20.4-45.9,12.4-45.9,12.4l3.2-17h38.5L361.5,124.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M359,120.9c-5.9,16.4-32.3,12.2-42,10.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M346.5,114c-13.1-0.4-20.9-3.1-24.7-4.8c-1.6-0.7-3.4,0-4,1.6l-2,5.3c-0.6,1.6,0.4,3.3,2.1,3.7l27,6.4 c1.7,0.4,3.4-0.7,3.6-2.4l0.9-6.6C349.6,115.5,348.2,114.1,346.5,114z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M353.6,114c13-0.4,20.6-3.1,24.3-4.8c1.5-0.7,3.4,0,4,1.6l2,5.3c0.6,1.6-0.4,3.3-2,3.7l-26.7,6.4 c-1.7,0.4-3.3-0.7-3.6-2.4l-0.9-6.6C350.6,115.5,351.9,114.1,353.6,114z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M319,109.3l0.7-9.8c0.1-0.9,0.7-1.6,1.6-1.7c1.7-0.3,3.1-1.6,3.5-6c0.8-8.8-3.6-10.4-3.6-10.4l0.8-9.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M369,81.5c0,0-0.1,4.8,2.9,10.8c2.2,4.4,5.8,5.2,7.4,5.3c0.6,0,1,0.5,1,1.1l0.8,10.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M340.8,83.7c-6-10.9-34.2-17.2-34.2-17.2C307,53.9,324,51.6,324,51.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st14",
  d: "M332.1,112.4c3.4-6.5,2.7-17.5,1.1-24.7c-0.4-2,1.2-4,3.2-3.9c8.1,0.1,25.4,0.1,32.5-2.3 c6.9-12.7,30.1-15.3,30.1-15.3c-0.9-10.1-22.9-13.9-22.9-13.9c0.3,3.1,0.9,9.4,1.2,12.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M369,81.5c0,0,5.4-14,10.7-17.4c1.5-1-2.6-2.4-2.6-2.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st17",
  d: "M340.8,83.7c0,0-7.8-13.8-20.8-19.6c-1.7-0.7,2.6-2.4,2.6-2.4"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M375.7,49.8c0,0,1.3,11.4,1.6,14.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st9",
  d: "M324.2,49.8c0,0-1.3,11.4-1.6,14.1"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M378.8,12c-5.4,1.7-16.3,2.9-29,2.9c-12.5,0-23.4-1.2-28.8-2.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M393,16.1c-9.1,2.7-25,4.5-43.2,4.5c-18.1,0-34.1-1.8-43.2-4.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st16",
  d: "M403.7,21.5C391.6,26,372,29,349.8,29c-22.2,0-41.9-3-53.9-7.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M336.4,155.8c0,0,7,1.9,12.8,1.9c5.7,0,14-1.5,14-1.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M336.5,153.3c0,0,7,1.9,12.8,1.9c5.7,0,14-1.5,14-1.5"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M360.6,127c0,0,3.6,3.8,13.6,4.4s13.2-0.9,13.2-0.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M358.5,131.2c0,0,5.3,4.6,15.3,5.2c10,0.6,15.7-1.3,15.7-1.3"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "st15",
  points: "298.6,21.8 298.6,32 312.6,25.4 319,37.7 333.3,28.1 340.8,39.9 351,28.8 359.9,39.8 368.6,28.1  380,38.1 386.3,26 398.8,34 400.2,23.9 408,26.8  "
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M342,113.5c0,0,0.5-11.6,0.4-16.6c-0.1-5-1.4-13.2-1.4-13.2"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M348.5,83.7c0,0,1.3,8.2,1.4,13.2c0.1,5-0.4,16.6-0.4,16.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M356.1,83.7c0,0,1.3,8.2,1.4,13.2c0.1,5-0.4,16.6-0.4,16.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M363.7,83.7c0,0,1.3,8.2,1.4,13.2s-0.4,16.6-0.4,16.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M372.3,91.6c0.2,1.8,0.3,3.7,0.4,5.2c0.1,3.7-0.2,11-0.3,14.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M356.1,114.4c0,0,0,6.4,0.7,6.9c1.5,1,18.8-3.7,26.8-5.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M346.9,113.9c0,0,0,6.4-0.7,6.9c-1.5,1-21.7-4.2-29.7-6.3"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M371.7,148L371.7,148c-1.3,0.4-2.7-0.4-3.1-1.8l-1.1-3.9c-0.4-1.3,0.4-2.7,1.8-3.1l0,0 c1.3-0.4,2.7,0.4,3.1,1.8l1.1,3.9C373.8,146.2,373,147.6,371.7,148z"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M368.6,135.4c0,0-1.3,2.3,0.7,3.8"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M367.5,142.5c0,0,1,0.8,2.7,0.2s2.2-1.6,2.2-1.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M368.2,144.9c0,0,1,0.8,2.7,0.2s2.2-1.6,2.2-1.6"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M329.4,73.7c0,0,0.4,9.4,0.4,15.1s-2.6,21.9-2.6,21.9"
}), /*#__PURE__*/React.createElement("path", {
  className: "st15",
  d: "M323.7,66.1c0,0,13.2,7.4,26.3,6.9c13.1-0.5,26.6-5.8,26.6-5.8"
})));

var SvgQ5Svg = function SvgQ5Svg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Q5svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 714.5 202",
    style: {
      enableBackground: "new 0 0 714.5 202"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQ5Svg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q5svg.a98fd028.svg";
export { ForwardRef as ReactComponent };